import type { ReactNode } from 'react';

import type { TickFormatter, TickRendererProps } from '@visx/axis';

/**
 * Common props shared across axis components
 */
export type AxisProps<T = unknown> = {
  tickFormat?: TickFormatter<T>;
  numTicks?: number;
  tickComponent?: (tickRendererProps: TickRendererProps) => ReactNode;
};

/**
 * Default number of ticks for y axis and grid
 */
export const DEFAULT_Y_TICKS = 5;
export const DEFAULT_X_TICKS = 4;
